export default "__VITE_ASSET__CTD7PjZa__"